import { getServiceURL } from "api/utils"
import { SERVICE_PREFIX } from "utils/constants"

export type GetAnalyticsUrlParams = {
  learningItemType: string
  learningItemId: string | number
}

export type GetTimeSpentAnalyticsUrlParams = {
  itemType: string
  itemId: string | number
}

const getCastorURL = getServiceURL(SERVICE_PREFIX.castor)

export const urls = {
  getAnalyticsData: ({
    learningItemId,
    learningItemType,
  }: GetAnalyticsUrlParams) =>
    `/v1/${learningItemType}/${learningItemId}/analytics/`,

  getTimeSpentAnalytics: ({
    itemId,
    itemType,
  }: GetTimeSpentAnalyticsUrlParams) =>
    getCastorURL(`/v2/planners/${itemType}/${itemId}/analytics/time/`),
}
